var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTranslationsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 35.5C27.665 35.5 35.5 27.665 35.5 18C35.5 8.33502 27.665 0.5 18 0.5C8.33502 0.5 0.5 8.33502 0.5 18C0.5 27.665 8.33502 35.5 18 35.5ZM17.1108 9.58112C16.3271 9.58112 15.6919 10.2164 15.6919 11C15.6919 11.7836 16.3271 12.4189 17.1108 12.4189H18.3329C19.1165 12.4189 19.7518 11.7836 19.7518 11C19.7518 10.2164 19.1165 9.58112 18.3329 9.58112H17.1108ZM11 13.2476H23.2021C23.2159 13.2474 23.2297 13.2474 23.2435 13.2476H25.6658C26.4495 13.2476 27.0847 13.8828 27.0847 14.6665C27.0847 15.4501 26.4495 16.0853 25.6658 16.0853H23.9809L21.9578 19.12C21.906 19.1977 21.8466 19.2702 21.7805 19.3362L19.7284 21.3883L23.0027 24.6626C23.5568 25.2167 23.5568 26.115 23.0027 26.6691C22.4486 27.2233 21.5502 27.2233 20.9961 26.6691L17.7218 23.3949L14.4476 26.6691C13.8935 27.2233 12.9951 27.2233 12.441 26.6691C11.8869 26.115 11.8869 25.2167 12.441 24.6626L15.7153 21.3883L13.6632 19.3362C13.1091 18.7821 13.1091 17.8837 13.6632 17.3296C14.2173 16.7755 15.1157 16.7755 15.6698 17.3296L17.7218 19.3817L19.6746 17.429L20.5703 16.0853H11C10.2164 16.0853 9.58112 15.4501 9.58112 14.6665C9.58112 13.8828 10.2164 13.2476 11 13.2476Z",
    fill: "#F46350"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslationsIcon);
export default __webpack_public_path__ + "static/media/translationsIcon.db211251b341b10e265d55e552159c92.svg";
export { ForwardRef as ReactComponent };